import { StandardEvents } from '@shopify/events';
(() => {
  const bindMenus = () => {
    document.querySelectorAll('[data-fep-menu-open]').forEach((toggle) => {
      if (toggle.dataset.fepBound) return;
      const dialog = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!dialog) return;
      toggle.dataset.fepBound = 'true';
      const close = () => dialog.close();
      toggle.addEventListener('click', () => {
        dialog.showModal();
        toggle.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('fep-menu-is-open');
      });
      dialog.querySelector('[data-fep-menu-close]').addEventListener('click', close);
      dialog.querySelectorAll('a').forEach(link => link.addEventListener('click', close));
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
      dialog.addEventListener('close', () => {
        toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('fep-menu-is-open');
        toggle.focus({preventScroll: true});
      });
      const wide = matchMedia('(min-width: 900px)');
      wide.addEventListener('change', event => { if(event.matches && dialog.open) close(); });
    });
  };
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise?.then(({cart, detail}) => {
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (Number.isInteger(count)) document.querySelectorAll('[data-fep-cart-count]').forEach(node => {node.textContent = String(count);});
    }).catch(() => {});
  });
  bindMenus();
  document.addEventListener('shopify:section:load', bindMenus);
  document.addEventListener('shopify:section:unload', () => {
    if (!document.querySelector('.fep-nav-dialog[open]')) document.documentElement.classList.remove('fep-menu-is-open');
  });
})();
